import React from 'react';
interface ChoiceChipsProps {
  legend: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  optional?: boolean;
}

/** Single-choice question rendered as large tappable chips (radio semantics). */
export function ChoiceChips({
  legend,
  options,
  value,
  onChange,
  optional = false
}: ChoiceChipsProps) {
  return <fieldset data-id="element-391" data-mp="v2jmj6nhbki1">
      <legend className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-392" data-mp="v5xr8ljm85sn">
        {legend}
        {optional && <span className="ml-2 normal-case tracking-normal text-steel-500" data-id="element-393" data-mp="152ai7bns05jp">Optional</span>}
      </legend>
      <div role="radiogroup" className="mt-2.5 flex flex-wrap gap-2" data-id="element-394" data-mp="1it5tsvpnt0qz">
        {options.map(option => {
        const selected = value === option;
        return <button key={option} type="button" role="radio" aria-checked={selected} onClick={() => onChange(selected ? '' : option)} className={`border px-3.5 py-2 text-[14px] font-semibold transition-colors duration-150 ease-grit focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${selected ? 'border-grit-500 bg-grit-500 text-ink-950' : 'border-white/20 text-offwhite hover:border-white/40'}`} data-id="element-395" data-mp="1dwfdc79y0351">
              {option}
            </button>;
      })}
      </div>
    </fieldset>;
}